import { t } from '@glory/i18n';

import { STAGES, type Stage } from './deal.ts';

/** Объект журнала настроек продаж: одна запись на студию. */
export const SETTINGS_ENTITY = 'sales_settings';
/** Идентификатор объекта «Истории» настроек (UUID версии 8): строка настроек одна. */
export const SETTINGS_ENTITY_ID = '00000000-0000-8000-8000-000000000002';

export const STAGE_TITLE_MAX = 40;
export const REASON_TITLE_MAX = 80;

/** Внутренние названия этапов, которые студия переименовала; остальные — по умолчанию. */
export type StageNames = Partial<Record<Stage, string>>;

/** Название для клиента (кабинет) от переименования не зависит — оно в `clientStageLabel`. */
export const defaultStageTitle = (stage: Stage): string => t(`sales.stages.${stage}`);

/** Внутреннее название этапа: переименованное или по умолчанию. */
export function stageTitle(stage: Stage, names: StageNames | null | undefined): string {
  const own = names?.[stage];
  return own === undefined || own.trim() === '' ? defaultStageTitle(stage) : own;
}

/** Название этапа или причины: пробелы схлопываются, пустое — null. */
export function normalizeLabel(value: string | null | undefined): string | null {
  const clean = (value ?? '').replace(/\s+/g, ' ').trim();
  return clean === '' ? null : clean;
}

/** Переименования из базы: лишнее и пустое отбрасывается, остаются только известные этапы. */
export function parseStageNames(value: unknown): StageNames {
  if (typeof value !== 'object' || value === null) return {};
  const names: StageNames = {};
  for (const stage of STAGES) {
    const raw = (value as Record<string, unknown>)[stage];
    const clean = typeof raw === 'string' ? normalizeLabel(raw) : null;
    if (clean !== null) names[stage] = clean;
  }
  return names;
}

/** Имя этапа с подменой: новые переименования поверх старых, `null` возвращает название по умолчанию. */
export function withStageName(names: StageNames, stage: Stage, title: string | null): StageNames {
  const rest = Object.fromEntries(Object.entries(names).filter(([key]) => key !== stage));
  return title === null ? rest : { ...rest, [stage]: title };
}
